<!-- Related to sharing asset message -->
<div *ngIf="configObject?.callFrom === 'shareAssets' && configObject?.createdBy" class="title w-full text-lg font-semibold mb-6 mt-7">
  Recommendation from {{ configObject?.createdBy }} on {{ configObject?.createdAt | spDateFormat: { isSafe: true } }}
</div>
<div class="asset-details-columns flex w-full h-full">
  <div class="asset-details-main-column widget-bg-color rounded-lg item p-4">
    <!-- Asset aspect ratio view -->
    <thehubz-aspect-ratio-view
      [aspectRatioData]="aspectRatioData"
      [changeSelection]="changeAspectRatioSelection"
      (clickUpdateTableData)="selectAspectRatio($event)"
      (deleteAspectRatio)="deleteAspectRatio($event)"
    ></thehubz-aspect-ratio-view>
  </div>
  <div class="asset-details-aside-column widget-bg-color rounded-lg item overflow-y-auto">
    <!-- Format list view -->
    <div class="p-2">
      <sp-custom-mat-table
        [tableCols]="columns"
        [tableData]="fileFormatData"
        [tableName]="'asset-variant-'"
        [actionColumn]="true"
        [showDownload]="this.sharedResource?.noDownload ? !this.sharedResource.noDownload : true"
        [showDelete]="AccessAsset(assetInfo) | can: 'aspectratios'"
        [showEdit]="(configObject?.callFrom !== 'shareAssets' ? true : false) && (AccessAsset(assetInfo) | can: 'aspectratios')"
        [showSearchFilter]="false"
        [showFilterMenu]="true"
        [addRowClick]="false"
        [disableDownload]="!(assetInfo && assetInfo.expiryDate | dateNotExpired)"
        (clickDownload)="downloadFileFormat($event)"
        (clickEdit)="editFileFormat($event)"
        (clickDelete)="deleteFileFormat($event)"
        class="teams-table"
      ></sp-custom-mat-table>
    </div>
  </div>
</div>
